import { LDContext } from 'launchdarkly-react-client-sdk';

/**
 * LaunchDarkly multi-context for backoffice. Mirrors lum-web's
 * FEATURE_FLAGS_CONTEXT but with `client_type: 'BACKOFFICE'` so flags can be
 * targeted to the backoffice surface specifically. The `user` context is
 * enriched with the real user id via `identify()` once the profile loads.
 */
const baseUser = {
  key: 'feature-flags-user-key',
  customerId: process.env.CUSTOMER_ID,
};

const platform = {
  key: 'feature-flags-platform-key',
  client_type: 'BACKOFFICE',
  platform: 'WEB',
};

/** Initial context passed to `withLDProvider` before the user is known. */
export const FEATURE_FLAGS_CONTEXT: LDContext = {
  kind: 'multi',
  user: baseUser,
  platform,
};

/**
 * Context enriched with the authenticated user id, for `identify()`.
 * Mirrors lum-web's `startFeatureFlags`: the user `key` stays the static
 * `baseUser.key`, and the real user id is added as the `userId` attribute so it
 * matches the LaunchDarkly targeting rules (which key off the `userId`
 * attribute, not the context key). backoffice has no `companyId` concept, so
 * only `userId` is added (lum-web also sends `companyId`).
 */
export const buildFeatureFlagsContext = (userId: string): LDContext => ({
  kind: 'multi',
  user: { ...baseUser, userId },
  platform,
});
